import { useState } from 'react';
import Api, { endpoints } from '@helpers/api';
import { toast } from 'react-toastify';
import moment from 'moment';

export default () => {
  const [is_loading, set_is_loading] = useState(false);
  const [images, set_images] = useState([]);
  const [description, set_description] = useState('');
  const [telescope_model, set_telescope_model] = useState('');
  const [telescope_focal_length, set_telescope_focal_length] = useState('');
  const [telescope_aperture, set_telescope_aperture] = useState('');
  const [camera_model, set_camera_model] = useState('');
  const [camera_resolution, set_camera_resolution] = useState('');
  const [camera_pixel, set_camera_pixel] = useState('');
  const [barlow, set_barlow] = useState('');
  const [iso, set_iso] = useState('');
  const [shutter_speed, set_shutter_speed] = useState('');
  const [aperture, set_aperture] = useState('');
  const [latitude, set_latitude] = useState('');
  const [longitude, set_longitude] = useState('');
  const [hijri_date, set_hijri_date] = useState('');
  const [datetime, set_datetime] = useState(moment());

  const onConfirmDraw = ({ lat, lng }) => {
    set_latitude(lat);
    set_longitude(lng);
  };

  const submit = () => {
    if (is_loading) return;
    if (images.length === 0) return alert('Please upload at least 1 image');
    if (!description) return alert('Please enter description');
    if (!latitude) return alert('Please enter latitude');
    if (!longitude) return alert('Please enter longitude');
    set_is_loading(true);
    Api({
      endpoint: endpoints.newHilal(),
      data: {
        input: {
          description,
          datetime,
          telescope_model,
          telescope_focal_length,
          telescope_aperture,
          camera_model,
          camera_resolution,
          camera_pixel,
          barlow,
          iso,
          shutter_speed,
          aperture,
          longitude,
          latitude,
          hijri_date,
        },
      },
      files: images,
      onSuccess: (res) => {
        console.log(res);
        set_is_loading(false);
        set_description('');
        set_images([]);
        toast.success('Successfully saved');
        // alert('Hilal successfully uploaded');
        // history.push('/hilal');
      },
      onFail: (err) => {
        set_is_loading(false);
        console.log(err);
      },
    });
  };

  return {
    images,
    set_images,
    submit,
    is_loading,
    description,
    set_description,
    datetime,
    set_datetime,
    telescope_model,
    set_telescope_model,
    telescope_focal_length,
    set_telescope_focal_length,
    telescope_aperture,
    set_telescope_aperture,
    camera_model,
    set_camera_model,
    camera_resolution,
    set_camera_resolution,
    camera_pixel,
    set_camera_pixel,
    barlow,
    set_barlow,
    iso,
    set_iso,
    shutter_speed,
    set_shutter_speed,
    aperture,
    set_aperture,
    latitude,
    set_latitude,
    longitude,
    set_longitude,
    onConfirmDraw,
    hijri_date,
    set_hijri_date,
  };
};
